export const mascaraTelefone = (tel?: string) => (tel || "").replace(/\D/g, "");
